<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-container" style="background-color: #000;">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg"
        :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText"
        :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in routes" :key="route.name" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
// 直接导入路由配置，避免在生产环境打包后通过 router.options 访问失败
import { routes } from '@/router/index'
// 导入权限过滤函数
import { filterRoutes } from '@/config/permission'

// 不再从 SCSS 导入 variables，因为在生产环境打包后可能无法正确读取
// 直接在组件中定义，确保在所有环境下都能正常工作
// import variables from '../../style/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar',
      'username'  // 添加 username getter
    ]),
    routes() {
      // 获取当前登录的用户名
      const currentUsername = this.username || sessionStorage.getItem('USERNAME')

      if (!currentUsername) {
        // 如果没有用户名，返回空数组（未登录状态）
        return []
      }

      // 根据用户名过滤路由
      const filteredRoutes = filterRoutes(routes, currentUsername)

      console.log('当前用户:', currentUsername)
      console.log('过滤后的路由:', filteredRoutes)

      return filteredRoutes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      // 直接在组件中定义样式变量，避免从 SCSS 导入在生产环境失败
      return {
        menuText: '#e1e6ed',
        menuActiveText: '#64b5f6',
        subMenuActiveText: '#ffffff',
        menuBg: '#1a2332', // 使用纯色替代渐变，因为 el-menu 的 background-color 属性不支持渐变
        menuHover: 'rgba(100, 181, 246, 0.12)',
        subMenuBg: 'rgba(10, 15, 20, 0.6)',
        subMenuHover: 'rgba(100, 181, 246, 0.18)',
        sideBarWidth: '210px'
      }
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss">
.router-link-active {
  text-decoration: none;
}

// 激活菜单项样式 - 现代化设计
.el-menu-item.is-active {
  position: relative;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.1) 0%, rgba(64, 158, 255, 0.05) 100%) !important;

  // 左侧高亮条
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #409EFF 0%, #66b1ff 100%);
    border-radius: 0 2px 2px 0;
  }

  span {
    color: #409EFF !important;
    font-weight: 500;
  }

  // 图标颜色
  .svg-icon,
  .el-icon {
    color: #409EFF !important;
  }
}

// 菜单项悬停效果优化
.el-menu-item,
.el-submenu__title {
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
  }
}

// 子菜单激活状态
.el-submenu.is-active>.el-submenu__title {
  color: #409EFF !important;

  .svg-icon,
  .el-icon {
    color: #409EFF !important;
  }
}
</style>
